import { render, staticRenderFns } from "./CopyCampaign.vue?vue&type=template&id=bacf66f6&scoped=true"
import script from "./CopyCampaign.vue?vue&type=script&lang=js"
export * from "./CopyCampaign.vue?vue&type=script&lang=js"
import style0 from "./CopyCampaign.vue?vue&type=style&index=0&id=bacf66f6&prod&lang=scss&scoped=true"
import style1 from "./CopyCampaign.vue?vue&type=style&index=1&id=bacf66f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacf66f6",
  null
  
)

export default component.exports